import React from 'react'

//component
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable'
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton'
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector'
import NotificationBar from  '@/components/elements/languages/NotificationBar'

//hooks
import UseAllUserGroupsScreen, {allUserGroupsConstants} from './AllUserGroupsScreen.hooks'
import LinkStyleButton from  '@/components/elements/global/buttons/LinkStyleButton'
import SimpleSearchInput from  '@/components/elements/search/simpleSearchInput'
import CheckboxPanel from  '@/components/elements/global/dropdown/CheckboxPanel'

//interface
import { ITableContent } from  '@/interfaces/simpleTable'

//styling
import "../../../../css/orgSettings/userGroups/usersGroups.scss"




const AllUserGroupsScreen = () => {  
    const {
        filterText,
        onAddNewUserGroupClick,
        tableContent,
        showSimpleTable,
        paginationSettings,
        setPage,
        showFilterPanel,
        includeArchivedUserGroups,
        setSearchString,
        searchString,
        setShowFilterPanel,
        notificationDetails,
        setIncludeArchivedUserGroups,
        isLoading
    } = UseAllUserGroupsScreen();

    return(
        <div className="all-user-groups-screen" data-testid="all-user-groups-screen">
            <span className="headers" >
                <h1>{allUserGroupsConstants.headerText}</h1>
                <BasicButton className="add-new-user-button" 
                    content={allUserGroupsConstants.addUserButtonText}
                    ariaLabel={allUserGroupsConstants.addUserButtonLabel}
                    onButtonClick={onAddNewUserGroupClick}
                />
            </span>

            <div className='user-groups-top-button-panel'> 
                <LinkStyleButton
                    content={filterText}
                    ariaLabel={allUserGroupsConstants.filterLabel}
                    onButtonClick={() => setShowFilterPanel(!showFilterPanel)}
                />
                <SimpleSearchInput
                    ariaLabel={allUserGroupsConstants.searchLabel}
                    setSearchString={setSearchString}
                    searchString={searchString}
                />
            </div>

            {showFilterPanel &&
                <CheckboxPanel
                    panelTitle={allUserGroupsConstants.filterPanelHeader}
                    items={[{id: 1, content:allUserGroupsConstants.filterArchiveLabel, isSelected: includeArchivedUserGroups, onCheck: () => setIncludeArchivedUserGroups(!includeArchivedUserGroups)}]}
                />
            }

            {showSimpleTable &&
                <SimpleTable
                    isLoading={isLoading}
                    simpleTableContent={tableContent as ITableContent}
                    noDataMessage={allUserGroupsConstants.noDataMessage}
                    maxContentLength={20}
                    isInfiniteScroll={false}
                />
            }
            
            {paginationSettings?.hasPagination &&
                <SimplePageSelector
                    currentPage={paginationSettings.currentPage}
                    totalPages={paginationSettings.totalPages}
                    setPage={setPage}
                />
            }

            <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
        </div>
    )
}

export default AllUserGroupsScreen